import React, { createContext, useContext, useRef, ReactNode } from 'react';

interface TutorialRefsContextType {
  menuButtonRef: React.RefObject<HTMLButtonElement>;
  restaurantSelectorRef: React.RefObject<HTMLDivElement>;
  statusButtonRef: React.RefObject<HTMLButtonElement>;
}

const TutorialRefsContext = createContext<TutorialRefsContextType | undefined>(undefined);

export const useTutorialRefs = () => {
  const context = useContext(TutorialRefsContext);
  if (!context) {
    throw new Error('useTutorialRefs must be used within a TutorialRefsProvider');
  }
  return context;
};

interface TutorialRefsProviderProps {
  children: ReactNode;
}

export const TutorialRefsProvider: React.FC<TutorialRefsProviderProps> = ({ children }) => {
  const menuButtonRef = useRef<HTMLButtonElement>(null);
  const restaurantSelectorRef = useRef<HTMLDivElement>(null);
  const statusButtonRef = useRef<HTMLButtonElement>(null);

  const value = {
    menuButtonRef,
    restaurantSelectorRef,
    statusButtonRef,
  };

  return (
    <TutorialRefsContext.Provider value={value}>
      {children}
    </TutorialRefsContext.Provider>
  );
}; 